
  import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
  import {ActivatedRoute} from "@angular/router";
import { LcCropperImgViewComponent } from '../lc-cropper-img-view/lc-cropper-img-view.component';
  @Component({
    selector: 'lc-view-image',
    templateUrl: './lc-view-image.component.html',
  })
  export class LcViewImageComponent implements OnInit,AfterViewInit {
    @ViewChild(LcCropperImgViewComponent) view: LcCropperImgViewComponent;
    imgUrl: string;
    constructor(private route: ActivatedRoute) {
    }
    ngAfterViewInit(): void {
      this.view.load(this.imgUrl);
    }
    ngOnInit(): void {
      this.imgUrl = this.route.snapshot.queryParams.imgUrl;
    }
  }
